import { render, staticRenderFns } from "./Infinity.vue?vue&type=template&id=81f77f7c"
import script from "./Infinity.vue?vue&type=script&lang=ts"
export * from "./Infinity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports